export default __webpack_public_path__ + "static/media/team_waghy.c318e21d.jpg";